import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { useSlideContext } from "@/components/Product/ProductSlider/components/slider/components/slides/components/slide/context/slide.context";
import { useRecentsContext } from "@/components/Product/ProductSlider/sources/recents/context/recents.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const DeleteFromHistoryButton = ({ className }: Props) => {
    const { t } = useGranite();

    const { deleteFromHistory } = useRecentsContext();

    const { product } = useSlideContext();

    const handleOnClick = (event: MouseEvent) => {
        event.preventDefault();

        deleteFromHistory(product.sku);
    };

    return (
        <Button
            className={cn(
                "tw:absolute tw:py-1 tw:px-2 tw:text-xl tw:z-1 tw:hidden tw:lg:block",
                className
            )}
            color={"transparent"}
            aria-label={t("accessibility.productSlider.delete")}
            onClick={handleOnClick}
        >
            <i className={cn("las la-times")} />
        </Button>
    );
};
